import { render, staticRenderFns } from "./OnboardingRecipientModal.vue?vue&type=template&id=2430f6ce&lang=pug"
import script from "./OnboardingRecipientModal.vue?vue&type=script&lang=js"
export * from "./OnboardingRecipientModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports